import { DataType } from 'components/table/types';

export enum systemMessagesTableTypes {
	GLOBAL = 'global',
	COMPANY = 'company',
}

export type SystemMessagesTableColumns = Record<systemMessagesTableTypes, Record<string, DataType>>;

export const tableColumns: SystemMessagesTableColumns = {
	[systemMessagesTableTypes.GLOBAL]: {
		internalDescription: 'string',
		createdAt: 'date',
		createdBy: 'string',
		iconType: 'custom',
		audienceType: 'custom',
		startDate: 'date',
		endDate: 'date',
		confirmedCount: 'integer',
		isLive: 'custom',
	},
	[systemMessagesTableTypes.COMPANY]: {
		internalDescription: 'string',
		createdAt: 'date',
		createdBy: 'string',
		iconType: 'custom',
		startDate: 'date',
		endDate: 'date',
		confirmedCount: 'integer',
		isLive: 'custom',
	},
};
